export default __webpack_public_path__ + "static/O0175-e1f7045903c41e8146773cfd296ea68d.png";